import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { message } from 'ant-design-vue';
import router from '@/router';

const hasToken = localStorage.getItem('ideax-common-token') || '0a47a65a-56d9-4abb-820b-8cbf75ca0422';
const http = axios.create({
  baseURL: './apis',
  withCredentials: true,
  timeout: 120000,
  headers: {
    'Cache-Control': 'no-cache',
    Authorization: `Bearer ${hasToken.replace(/\"/g, "")}`
  }
});

http.interceptors.request.use((config: AxiosRequestConfig) => {
  return config;
});

const whitelist = ['/v1/sources/precheck_sql', '/v1/subtabledef/excute-sql', '/v1/data/processes/parseFlinkSql', '/v1/data/processes/parseDorisSql'];

http.interceptors.response.use(
  (response: AxiosResponse<any>) => {
    return response.data;
  },
  error => {
    let res = error.response;
    if (res) {
      debugger
      let msg = res.data.header?.msg;
      let url = res.config.url;
      if (whitelist.includes(url)) {
        return res.data;
      }
      
      console.log(res.status)
      console.log(router.currentRoute)
      const fullPath = encodeURIComponent(window.location.href);
      // const fullPath = encodeURIComponent(router.currentRoute.fullPath)
      if (res.status == 401) {
        // 401: 未登录
        localStorage.removeItem('ideax-common-token');
        router.replace({
          path: '/login'
          //query: { redirect: fullPath }
        })
      } else if (res.status == 403) {
        // 403 token过期
        message.error('登录过期，请重新登录');
        localStorage.removeItem('ideax-common-token');
        // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
        // https://meta.kstartup.cn/ideax-data/#/data/datasource/detail?id=1
        setTimeout(() => {
          router.replace({
            path: '/login'
          })
        }, 1000)
      } else {
        message.error(msg ? msg : 'Server Error!');
      }
      return false;
    } else {
      message.error('服务异常，无法访问');
      return false;
    }
  }
);

export default http;
